import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class IngredientService {

  host:string;
  
  constructor(
    private hostService:HostService,
    private http:HttpClient,

  ) {
    this.host=this.hostService.host;
  }
  getIngredientsCatFamSizeBySize(cat,fam,size){
    return this.http.get(this.hostService.host+'ingredientsCatFamSize/category/'+cat+'/family/'+fam+'/size/'+size)
  }
  getObligatoryIngredientOfProduct(idProduct){
    return this.http.get(this.hostService.host+'ingredients/obligatoryIngredient/element/'+idProduct)
  }
  getObligatorySuppOfProduct(idProduct){
    return this.http.get(this.hostService.host+'ingredients/obligatorySupp/element/'+idProduct)
  }
}
